import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.931 1.277h-5.11a2.676 2.676 0 0 0-2.67 2.67v8.18a2.676 2.676 0 0 0 2.67 2.67h6.36a2.676 2.676 0 0 0 2.67-2.67V5.2Zm2.42 10.85a1.178 1.178 0 0 1-1.17 1.17h-6.36a1.171 1.171 0 0 1-1.17-1.17v-8.18a1.171 1.171 0 0 1 1.17-1.17h4.43v3.11h3.1Z';
const draw24px =
  'M14.94,1.89H7.05A3.76,3.76,0,0,0,3.3,5.63V18.37a3.76,3.76,0,0,0,3.75,3.75H17a3.76,3.76,0,0,0,3.75-3.75V7.64ZM19.2,18.37A2.25,2.25,0,0,1,17,20.62H7.05A2.25,2.25,0,0,1,4.8,18.37V5.63A2.25,2.25,0,0,1,7.05,3.38h6.89V8.64H19.2Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DocumentEmptyIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'documentEmpty')) as IconWithRender;

DocumentEmptyIcon.displayName = 'DocumentEmptyIcon';
DocumentEmptyIcon.propTypes = Icon.propTypes;
DocumentEmptyIcon.renderIcon = (props) => <DocumentEmptyIcon {...props} />;
export default DocumentEmptyIcon;
